<template>
    <div class="g pop-up-inner">
        <mdToggleAside
            @sendEvent="close"
        ></mdToggleAside>
        <mdCaption
            :caption="$t('popup.dropshipping.caption.dropshipping')"
        ></mdCaption>
        <div class="g pop-up-content">
            <div class="g pop-up-content-inner">
                <div class="g">
                    <div class="fieldset">
                        <label>{{ $t('popup.dropshipping.caption.recipient') }}</label>
                        <div class="cp input select" :class="[errors.has('adcuno')? 'is-error': '']" :data-error="errors.first('adcuno')">
                            <pre>{{division}},{{division == 'TRL'}}</pre>
                            <select  v-if="division == 'TRL'" v-model="result.adcuno" v-validate="''" name="adcuno" id="adcuno">
                                <option value="">{{ $t('site.noun.select') }}</option>
                                <option v-for="item in options || []" :key="item.adcuno" :value="item.adcuno">{{ item.adcuno }} / {{item.dlsite }}</option>
                            </select>
                            <select  v-else v-model="result.adcuno" v-validate="''" name="adcuno" id="adcuno">
                                <option value="">{{ $t('site.noun.select') }}</option>
                                <option v-for="item in options || []" :key="item.adcuno" :value="item.adcuno">{{ item.adcuno }} / {{item.cufn }}</option>
                            </select>
                        </div>
                    </div>
                     <div class="fieldset">
                        <label>{{ $t('popup.dropshipping.caption.customerorder') }}</label>
                        <div class="cp input text" :class="[errors.has('cuodno')? 'is-error': '']" :data-error="errors.first('cuodno')">
                            <input v-model="result.cuodno" type="text" v-validate="'max:25'" name="cuodno" id="cuodno">
                        </div>
                    </div>
                    <div class="fieldset">
                        <label>{{ $t('popup.dropshipping.caption.customeradd') }}</label>
                        <div class="cp input text" disabled>
                            <input :value="dlsite" type="text" disabled>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <mdBtnList
            :content="btns"
            :block="true"
            @sendEvent="receiveEvent"
        ></mdBtnList>
    </div>
</template>

<script>
    import mdCaption from '@/components/mdCaption'
    import mdToggleAside from '@/components/mdToggleAside'
    import mdBtnList from '@/components/mdBtnList'
    import { mapGetters, mapMutations, mapState } from 'vuex'

    export default {
        components: {
            mdCaption,
            mdToggleAside,
            mdBtnList,
        },
        props: {
            sn: {
                require: true
            },
            content: { //依照模板定義
                require: false,
                default: () => {
                    return {}
                }
            }
        },
        data: function(){

            return {
                result: {
                    cuodno: '',
                    adcuno: '',
                },
                options: [],
            }
        },
        computed: {
            ...mapState([ 
                'user'
            ]),
            ...mapGetters([
                'division'
            ]),
            btns: function(){

                return [
                    {
                        text:this.$t('popup.addclient.func.submit'),
                        themes: 'major',
                        func: 'action',
                    }
                ]
            },
            target: function(){
                let $result = this.result,
                    _adcuno = $result.adcuno;

                let $options = this.options,
                    $target = $options.find(item => item.adcuno === _adcuno);

                if( $target ) {
                    return $target;
                }else {
                    return null;
                }
                
            },
            dlsite: function(){
                let $target = this.target;
                
                if( $target) {
                    return $target.dlsite;
                }else {
                    return '';
                }
            },
        },
        methods: {
            ...mapMutations([
                'catchError',
            ]),
            action: function(){

                this.$validator.validate().then(result => {
                    if (!result){
                        //啊就沒通過啊
                    }else {

                        let $content = this.content,
                            $_action = $content.action;

                        let $result = this.result,
                            $target = this.target;

                        if(!$result.adcuno && !$result.cuodno){
                           
                        }else if( !$target ){
                            $_action({
                                cuodno: $result.cuodno,
                                adcuno: $result.adcuno,
                                cufn: '',
                                dlsite: '',
                            });
                        }else{
                            $_action({
                                cuodno: $result.cuodno,
                                adcuno: $result.adcuno,
                                cufn: $target.cufn,
                                dlsite: $target.dlsite,
                            });
                        }

                        this.close();
                    }
                });
            },
            getOption: function(){
                let $type = this.content.type,
                    _inqtno = this.content.inqtno,
                    _codiv = this.content.codiv,
                    $condiction = {}

                let _url = this.$siteTool.apiUrl({
                        class: 'AdcunoAddress',
                        func: 'List',
                    });

                if($type == 1 ){ //報價單時傳單號
                    $condiction = {
                            inqtno: _inqtno
                        }
                    return this.$http.post(_url, $condiction);
                }else{
                    $condiction = {
                            codiv: _codiv
                        }
                    return this.$http.post(_url, $condiction);
                }
            },
            // initOption: function(data){
            //     let $codiv = this.content.codiv,
            //         $result = data.filter(item =>{
            //             return item.codiv === $codiv
            //         });
            //     this.$set(this, 'options', $result);
            // },
            init: async function(){

                try {
                    let $response = await this.getOption();

                    this.$set(this, 'options', $response);
                    
                }catch(error) {

                    this.catchError({
                        error: error,
                        callback: this.init,
                    });
                }
            },
            close: function(){
                this.$emit('sendEvent', 'clearPopUp', this.sn);
            },
        },
        created: function(){
            this.init();
        }
    }
</script>

<style scoped lang="scss">

    .g.btn {
        padding-top: $interval-l;
    }

    .fieldset {
        padding: $interval-xs 0;

        label {
            display: block;
            margin-bottom: $interval-s;
        }
    }
</style>
